import {HttpClient} from "@angular/common/http";

export class SharedService {
  constructor(protected httpClient: HttpClient) {
  }
}
